import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to #anchors after in-app navigation (waits for sections that render after data loads).
export default function ScrollToHash() {
  const { hash, pathname, key } = useLocation();
  useEffect(() => {
    if (!hash) return;
    let tries = 0;
    const t = setInterval(() => {
      const el = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (el || ++tries > 30) {
        clearInterval(t);
        el?.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 100);
    return () => clearInterval(t);
  }, [hash, pathname, key]);
  return null;
}
